import React from 'react';

import ShowLessonsFinanciara from './ShowLessonsFinanciara';

const ShowLessonsFinanciaraTestPage = () => {
  return (
    <>
     
      <ShowLessonsFinanciara />
    </>
  );
};

export default ShowLessonsFinanciaraTestPage;
